import React from 'react';
import { NavLink } from 'react-router-dom';
import Auth from '../../../Helpers/auth';

const CompanyCheck = () => {
  const { data } = Auth.getProfile();

  return (
    <>
      {(data?.type === 'Manager' || data?.type === 'Admin') && (
        <NavLink to="/company">Company Dashboard</NavLink>
      )}
      {data?.type === 'Admin' && <NavLink to="/admin">Admin Dashboard</NavLink>}
    </>
  );
};

export default CompanyCheck;
